import { createSelector } from 'reselect';

const selectFinancial = (state) => state.financial;

const selectFinancialBalance = createSelector(
	selectFinancial,
	(financial) => financial?.balance
);

const selectFinancialBalanceDetails = createSelector(
	selectFinancial,
	(financial) => financial?.balance_details
);

const selectVerifiedPayment = createSelector(
	selectFinancial,
	(financial) => financial?.verify_payment
);

const selectRequestedPayment = createSelector(
	selectFinancial,
	(financial) => financial?.payment_request
);

const selectPaymentRequestHistoryList = createSelector(
	selectFinancial,
	(financial) => financial?.payment_history_list
);

const selectPaymentDetails = createSelector(
	selectFinancial,
	(financial) => financial?.payment_details
);

const selectFinancialTransactions = createSelector(
	selectFinancial,
	(financial) => financial?.transactions
);

const financialSelectors = {
	selectFinancial,
	selectFinancialBalance,
	selectFinancialBalanceDetails,
	selectVerifiedPayment,
	selectRequestedPayment,
	selectPaymentRequestHistoryList,
	selectPaymentDetails,
	selectFinancialTransactions,
};

export default financialSelectors;
